<pagination-template
  class="pagination_container"
  #p="paginationApi"
  (pageChange)="pageChange.emit($event)"
>
  <ul class="pagination">
  <li class="page-item previous" [class.disabled]="p.isFirstPage()">
    <a class="page-link cursor-pointer"  (click)="p.previous()">
      <i class="previous"></i>
    </a>
  </li>

  <li
    class="page-item"
    *ngFor="let page of p.pages"
    [ngClass]="{'active':p.getCurrent() === page.value}"
  >
    <a
      class="page-link cursor-pointer"
      (click)="p.setCurrent(page.value)"
      *ngIf="p.getCurrent() !== page.value"
    >
      <span>{{ page.label }}</span>
    </a>
    <a   class="page-link cursor-pointer" *ngIf="p.getCurrent() === page.value">
      <span>{{ page.label }}</span>
    </a>
  </li>
<!--    *ngIf="!p.isLastPage()"-->
  <li class="page-item next" [class.disabled]="p.isLastPage()">
    <a  class="page-link cursor-pointer"  (click)="p.next()">
      <i class="next"></i>
    </a>
  </li>
  </ul>
</pagination-template>

